import { Fragment, memo, ReactElement } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilter from './form';

interface FilterPracticeProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  authPerson?: string;
  isResearch?: boolean;
}

const FilterPracticeComponent = ({
  open,
  setOpen,
  authPerson,
  isResearch,
}: FilterPracticeProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-practice-content"
          id="panel-filter-practice-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter authPerson={authPerson} isResearch={isResearch} />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

FilterPracticeComponent.displayName = 'Practice Research - Filter Practice component';

const FilterPractice = memo(FilterPracticeComponent);

export default FilterPractice;
